// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__256Su","left":"styles_left__zYrG0"};